import React, { Component } from "react";

import styles from "./styles.scss";
import { connect } from "react-redux";
import { actions } from "./redux";

import CSSModules from "react-css-modules";
import { Checkbox, FormControlLabel } from "@material-ui/core";


@CSSModules(styles, { allowMultiple: true })
class ImportStatusOverview extends Component {


  constructor(props) {

    super(props);
    this.state = {
      id: props.match.params.id,
      showStackTrace: props.showStackTrace,
      logs: props.logs,
      importStatus: props.importStatus
    };
  }

  componentDidMount() {
  }

  render() {
    return (
      <div>
        {this.renderStatusOverview(this.props.importStatus)}
        {this.renderImportLog(this.props.logs, this.props.showStackTrace)}
      </div>
    );
  }

  renderStatusOverview(importStatus) {

    if (importStatus == null || importStatus.status == null)
      return <div></div>;

    let innerBlock;

    switch (importStatus.status) {
      case 'pending':
        innerBlock = <div>This import is still pending. No further information is available at this point.</div>;
        break;
      case 'importing':
        innerBlock = <div>Import is in process. Please refresh the page in a few moments for further information.</div>;
        break;
      case 'config_incomplete':
        innerBlock = <div>
          <div>
            Import completed successfully with no errors. However, not all of the master rules imported have been
            configured. Head to the Tag Labels and Rules tab (above) for further setup.
          </div>
        </div>;
        break;
      case 'complete':
        innerBlock = <div>Import completed successfully with no errors.</div>;
        break;
      case 'failed':
        innerBlock = <div>
          Import failed. Check the error log below for information on why the process failed, and, if
          possible, fix the imported spreadsheet and try again.
        </div>;
        break;
      default:
        innerBlock = <div>The import is in an unknown state. Error: IMPORT_ERR_UNKNOWN</div>;
        break;
    }

    return (
      <div style={{marginLeft: "0.5rem"}}>
        <h2>Status Overview</h2>
        <div>
          {innerBlock}
        </div>
      </div>
    );

  }

  renderImportLog(logs, showStackTrace) {
    return (
      <div style={{display: "grid"}}>
        <FormControlLabel style={{ justifySelf: 'right', marginTop: "2rem" }}
                          control={
                            <Checkbox
                              checked={this.props.showStackTrace}
                              onChange={e => {
                                this.props.toggleStackTrace();
                              }}
                              color="primary"
                            />
                          }
                          label="Show Stacktrace"
        />

        <div styleName="log-array">

          {logs.filter(x => x.logType !== 'trace').map((log, i) => {

            // TODO: Hide 'trace' log entries by default
            return (
              (!showStackTrace && log.forceShowLogEntry !== true && log.logType === "stacktrace")
                ? <div key={"log-entry-" + i} styleName="log-entry clickable" log-type={log.logType}
                       onClick={() => {
                         log.forceShowLogEntry = true;
                         this.setState({ logs: logs });
                       }}>
                  {i + 1}: Stack trace hidden. Click to show.
                </div>
                : <div key={"log-entry-" + i} styleName="log-entry" log-type={log.logType}>
                  {i + 1}: {log.text.split('\n').map((x, i) => <div key={"split-log-line-" + i}>{x}</div>)}
                </div>
            );
          })}

        </div>
      </div>
    );
  }
}

const bindAction = dispatch => {
  return {
    toggleStackTrace: () => dispatch(actions.toggleStackTrace())
  };
};

const mapStateToProps = state => ({
  showStackTrace: state.importStatusOverview.showStackTrace,
});

export default connect(
  mapStateToProps,
  bindAction
)(ImportStatusOverview);



// WEBPACK FOOTER //
// ./src/ui/ImportOverview/ImportStatus/ImportStatusOverview/ImportStatusOverview.js